import axios from '../../plugins/axios';

export const editBusinessService = ({}, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.put(`/api/business/${data.businessId}/service/${data.serviceId}`, data, config)
    .then((response) => response )
    .catch((error) => error.response );
};

export const createBusinessService = ({}, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.post(`/api/business/${data.businessId}/service`, data, config)
    .then((response) => response )
    .catch((error) => error.response );
}

export const allUpdateBusinessServices = ({}, { serviceId, data }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.put(`/api/service/${serviceId}/business-service-all-update`, data, config)
    .catch(err => err.response );
}